import React from 'react';
import PropTypes from 'prop-types';
import ViewerIcon from '@components/shared/ImageViewer/ViewerIcon';

/** One glyph: an uploaded SVG masked in the current colour, or a built-in icon. */
export default function GlyphPreview({ glyph, size = 16 }) {
    if (!glyph) return null;
    if (glyph.url) {
        return (
            <span
                aria-hidden="true"
                style={{
                    display: 'inline-block',
                    width: size,
                    height: size,
                    backgroundColor: 'currentColor',
                    WebkitMaskImage: `url("${glyph.url}")`,
                    maskImage: `url("${glyph.url}")`,
                    WebkitMaskSize: 'contain',
                    maskSize: 'contain',
                    WebkitMaskRepeat: 'no-repeat',
                    maskRepeat: 'no-repeat',
                    WebkitMaskPosition: 'center',
                    maskPosition: 'center',
                }}
            />
        );
    }
    return <ViewerIcon name={glyph.builtin || glyph.role || 'close'} />;
}

GlyphPreview.propTypes = {
    glyph: PropTypes.object,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
